import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import IconTick from 'components/icons/iconTick';
import IconHeart2 from 'components/icons/iconHeart2';
import IconLightningBoltFilled from 'components/icons/IconLightningBoltFilled';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import MaterialThumbnailWrapper from './MaterialThumbnailWrapper';
const DEFAULT_TOGGLE_FLYOUT = () => {};
const MaterialThumbnailUI = t0 => {
  const $ = _c(62);
  const {
    customToggleFlyOut: t1,
    customToggleFlyOutData: t2,
    fullHeightThumbnail: t3,
    image,
    isDisabled: t4,
    isFavMaterial: t5,
    isInFlashSale: t6,
    isRound: t7,
    isSelected: t8,
    label,
    materialApplicableForProduct,
    materialId,
    onClick,
    onDblClick,
    onHover,
    toggleFlyOut: t9,
    variant
  } = t0;
  const customToggleFlyOut = t1 === undefined ? false : t1;
  const customToggleFlyOutData = t2 === undefined ? null : t2;
  const fullHeightThumbnail = t3 === undefined ? false : t3;
  const isDisabled = t4 === undefined ? false : t4;
  const isFavMaterial = t5 === undefined ? false : t5;
  const isInFlashSale = t6 === undefined ? false : t6;
  const isRound = t7 === undefined ? false : t7;
  const isSelected = t8 === undefined ? false : t8;
  const toggleFlyOut = t9 === undefined ? DEFAULT_TOGGLE_FLYOUT : t9;
  const isTouchDevice = useIsTouchDevice();
  const {
    isDesktop,
    isMobile
  } = useScreen();
  const hasClickHandler = !!onClick;
  const shouldTriggerHover = !isMobile && !!onHover && !!materialApplicableForProduct;
  let t10;
  if ($[0] !== customToggleFlyOut || $[1] !== customToggleFlyOutData || $[2] !== isDesktop || $[3] !== materialId || $[4] !== onHover || $[5] !== shouldTriggerHover || $[6] !== toggleFlyOut) {
    t10 = () => {
      if (isDesktop) {
        if (customToggleFlyOut && customToggleFlyOutData) {
          toggleFlyOut(true, customToggleFlyOutData);
        } else {
          toggleFlyOut(true, materialId);
        }
      }
      if (shouldTriggerHover) {
        onHover();
      }
    };
    $[0] = customToggleFlyOut;
    $[1] = customToggleFlyOutData;
    $[2] = isDesktop;
    $[3] = materialId;
    $[4] = onHover;
    $[5] = shouldTriggerHover;
    $[6] = toggleFlyOut;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const onMouseEnter = t10;
  let t11;
  if ($[8] !== isDesktop || $[9] !== materialId || $[10] !== toggleFlyOut) {
    t11 = () => {
      if (isDesktop) {
        toggleFlyOut(false, materialId);
      }
    };
    $[8] = isDesktop;
    $[9] = materialId;
    $[10] = toggleFlyOut;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const onMouseLeave = t11;
  const t12 = variant === "PDPShownInUI--grey-background";
  let t13;
  if ($[12] !== isSelected || $[13] !== t12) {
    t13 = classNames("border-2 border-solid border-white rounded-lg h-full w-full", "first:shadow-[inset_0_0_0_1px_#f6f6f6,inset_0_0_0_4px_#fff]", {
      "!border-0": t12,
      "shadow-[inset_0_0_0_1px_#737373,inset_0_0_0_4px_#fff]": isSelected
    });
    $[12] = isSelected;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const t14 = onClick ?? undefined;
  const t15 = !isTouchDevice && onDblClick ? onDblClick : undefined;
  const t16 = variant === "PDPShownInUI" || variant === "PDPShownInUI--grey-background";
  const t17 = variant === "PDPShownInUI--grey-background";
  const t18 = hasClickHandler && !isRound;
  const t19 = hasClickHandler && !isRound && !isSelected;
  const t20 = variant === "PDPFabricUpChargeModal";
  let t21;
  if ($[15] !== isDisabled || $[16] !== isRound || $[17] !== isSelected || $[18] !== t16 || $[19] !== t17 || $[20] !== t18 || $[21] !== t19 || $[22] !== t20) {
    t21 = classNames("items-center rounded-lg flex h-full justify-center [transition:box-shadow_25ms_ease-in] w-full", {
      "!rounded-[50%]": t16,
      "!shadow-[inset_0_0_0_1px_#f1f1f1,inset_0_0_0_2px_#f1f1f1]": t17,
      "relative !shadow-[inset_0_0_0_1px_#262626,inset_0_0_0_3px_#fff]": isDisabled,
      "!shadow-[inset_0_0_0_1px_#262626,inset_0_0_0_4px_#fff]": isSelected,
      "rounded-full": isRound,
      "shadow-[inset_0_0_0_1px_#fff,inset_0_0_0_4px_#fff] focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand": t18,
      "hover:shadow-[inset_0_0_0_1px_#737373,inset_0_0_0_4px_#fff]": t19,
      "!rounded-none": t20
    });
    $[15] = isDisabled;
    $[16] = isRound;
    $[17] = isSelected;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] !== image) {
    t22 = image ? {
      background: `url(${image}?auto=format%2Ccompress&w=50&h=50&dpr=2&cs=srgb&rect=0,0,100,100) 0% 0% / 100% 100% no-repeat`
    } : undefined;
    $[24] = image;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  const t23 = onClick ? `Select ${label}` : label;
  const t24 = hasClickHandler ? "radio" : undefined;
  const t25 = hasClickHandler ? "0" : undefined;
  const t26 = onClick ? `Select ${label}` : label;
  const t27 = isFavMaterial && isSelected;
  let t28;
  if ($[26] !== isFavMaterial || $[27] !== t27) {
    t28 = classNames("hidden", {
      "block z-[1] [&_svg]:absolute [&_svg]:bottom-2 [&_svg]:right-2 [&_svg]:w-[.6rem] [&_svg]:h-[.6rem]": isFavMaterial,
      "[&_svg]:w-[.6rem] [&_svg]:h-[.6rem]": t27
    });
    $[26] = isFavMaterial;
    $[27] = t27;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <IconHeart2 fill="white" color="white" />;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] !== t28) {
    t30 = <div className={t28}>{t29}</div>;
    $[30] = t28;
    $[31] = t30;
  } else {
    t30 = $[31];
  }
  let t31;
  if ($[32] !== isSelected) {
    t31 = isSelected && <IconTick className="MaterialThumbnailUI__icon" height="22px" width="22px" />;
    $[32] = isSelected;
    $[33] = t31;
  } else {
    t31 = $[33];
  }
  let t32;
  if ($[34] !== isDisabled) {
    t32 = isDisabled ? <><div className="absolute left-0 top-0 bg-[hsla(0,0%,100%,.4)] w-full h-full z-50" /><div className="absolute left-0 top-0 w-full h-full z-[51] [background:linear-gradient(to_top_left,transparent_0,transparent_calc(50%_-_.8px)_,#fff_50%,transparent_calc(50%_+_.8px)_,transparent)] rounded-lg" /></> : null;
    $[34] = isDisabled;
    $[35] = t32;
  } else {
    t32 = $[35];
  }
  let t33;
  if ($[36] !== isInFlashSale) {
    t33 = isInFlashSale ? <div className="w-4 h-4 absolute top-[7px] left-2"><IconLightningBoltFilled color="white" height={13} width={12} /></div> : null;
    $[36] = isInFlashSale;
    $[37] = t33;
  } else {
    t33 = $[37];
  }
  let t34;
  if ($[38] !== isSelected || $[39] !== t14 || $[40] !== t15 || $[41] !== t21 || $[42] !== t22 || $[43] !== t23 || $[44] !== t24 || $[45] !== t25 || $[46] !== t26 || $[47] !== t30 || $[48] !== t31 || $[49] !== t32 || $[50] !== t33) {
    t34 = <div onClick={t14} onDoubleClick={t15} className={t21} style={t22} aria-checked={isSelected} aria-label={t23} role={t24} tabIndex={t25} title={t26}>{t30}{t31}{t32}{t33}</div>;
    $[38] = isSelected;
    $[39] = t14;
    $[40] = t15;
    $[41] = t21;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
    $[45] = t25;
    $[46] = t26;
    $[47] = t30;
    $[48] = t31;
    $[49] = t32;
    $[50] = t33;
    $[51] = t34;
  } else {
    t34 = $[51];
  }
  let t35;
  if ($[52] !== onMouseEnter || $[53] !== onMouseLeave || $[54] !== t13 || $[55] !== t34) {
    t35 = <div className={t13} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>{t34}</div>;
    $[52] = onMouseEnter;
    $[53] = onMouseLeave;
    $[54] = t13;
    $[55] = t34;
    $[56] = t35;
  } else {
    t35 = $[56];
  }
  let t36;
  if ($[57] !== fullHeightThumbnail || $[58] !== hasClickHandler || $[59] !== t35 || $[60] !== variant) {
    t36 = <MaterialThumbnailWrapper hasClickHandler={hasClickHandler} fullHeightThumbnail={fullHeightThumbnail} variant={variant}>{t35}</MaterialThumbnailWrapper>;
    $[57] = fullHeightThumbnail;
    $[58] = hasClickHandler;
    $[59] = t35;
    $[60] = variant;
    $[61] = t36;
  } else {
    t36 = $[61];
  }
  return t36;
};
MaterialThumbnailUI.propTypes = {
  customToggleFlyOut: PropTypes.bool,
  customToggleFlyOutData: PropTypes.object,
  fullHeightThumbnail: PropTypes.bool,
  image: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFavMaterial: PropTypes.bool,
  isInFlashSale: PropTypes.bool,
  isRound: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  materialApplicableForProduct: PropTypes.bool,
  materialId: PropTypes.number,
  onClick: PropTypes.func,
  onDblClick: PropTypes.func,
  onHover: PropTypes.func,
  toggleFlyOut: PropTypes.func,
  variant: PropTypes.oneOf(['PDPCustomerPhotosReviewsModal', 'PDPShownInUI', 'PDPShownInUI--grey-background'])
};
export default MaterialThumbnailUI;